import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import Sidebar from "../../Sidebar";

export default function AkbariMandiCreate() {
  const [akbariMandiRates, setAkbariMandiRates] = useState({
    date: (new Date()).toISOString().split("T")[0],
    product:"Sugar",
    product_id:"2",
    by_product:"akbari_mandi",
    by_product_id:"17",
    province_id:4,
    province:"Punjab",
    lcu_id:"10",
    district_id:"57",
    station_id:"661",
    station:"Lahore",
    spot_price_central_punjab:0,
    spot_price_southern_punjab:0,
    wholesale:0
  })

  const navigate = useNavigate();


  useEffect(() => {
    setAkbariMandiRates((prevRates) => ({
      ...prevRates,
      wholesale: Number(prevRates.spot_price_central_punjab) + 1.75,
    }));
  }, [akbariMandiRates.spot_price_central_punjab]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");

    fetch(`${process.env.REACT_APP_API_URL}/admin/prices`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify([akbariMandiRates]),
    })
      .then(() => {
        navigate("/akbari-mandi");
      })
      .catch((err) => {
        console.log("Unable to add record", err);
      });
  };


  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div>
        <form onSubmit={handleSubmit} className="needs-validation">
          <div>
            <div className="mb-3" id="bydrop">
              <label htmlFor="date" className="form-label">
                Date
              </label>
              <input
                id="num-value"
                type="date"
                className="form-control"
                required
                value={akbariMandiRates.date}
                onChange={(e) => setAkbariMandiRates({...akbariMandiRates, date:(new Date(e.target.value)).toISOString().split("T")[0]})}
              />
            </div>
          </div>

          <div>
            <div className="mb-3" id="values-num">
              <label htmlFor="number" className="form-label">
                Central Punjab
              </label>
              <input
                id="num-value"
                // type="text"
                className="form-control"
                min="0"
                onChange={(e) => setAkbariMandiRates({...akbariMandiRates, spot_price_central_punjab:Number(e.target.value)})}
                required
              />
            </div>


            <div className="mb-3" id="values-num">
              <label htmlFor="number" className="form-label">
                Wholesale
              </label>
              <input
                id="num-value"
                // type="text"
                className="form-control"
                min="0"
                value={akbariMandiRates.wholesale}
                disabled
                required
              />
            </div>


            <div className="mb-3" id="values-num">
              <label htmlFor="number" className="form-label">
                South Punjab
              </label>
              <input
                id="num-value"
                // type="text"
                className="form-control"
                min="0"
                onChange={(e) => setAkbariMandiRates({...akbariMandiRates, spot_price_southern_punjab:Number(e.target.value)})}
              />
            </div>
            <button type="submit" id="values-num" className="mb-3 btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
